import styled from 'styled-components'

const NAV_BAR_HEIGHT = 43
const BUTTON_CONTAINER_HEIGHT = 69

export const ButtonLibrary = styled.button`
  height: 28px;

  display: flex;
  align-items: center;
  gap: 6px;

  background-color: white;
  outline: none;
  border: none;
  cursor: pointer;

  border-radius: 6px;
  border: 1px solid var(--border-neutral, #bbc1d3);

  padding: 4px 8px;
  box-sizing: border-box;

  color: var(--foreground-neutral-faded, #4d5874);

  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const LibraryImg = styled.img``

export const Container = styled.div`
  width: 296px;
  min-height: 300px;

  border-radius: 6px 0px;
  border: 1px solid var(--border-neutral, #bbc1d3);
  background: var(--persistent-white, #fff);

  /* Overlay */
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.07), 0px 5px 10px 0px rgba(0, 0, 0, 0.05);

  overflow: hidden;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 12px 16px 12px 24px;
  box-sizing: border-box;

  border-bottom: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--persistent-white, #fff);
`

export const HeaderTitle = styled.label`
  color: var(--foreground-neutral, var(--foreground-neutral, #14171f));

  /* Body 2/Medium */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`

export const ButtonClose = styled.button`
  background-color: white;
  outline: none;
  border: none;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 36px;
  height: 36px;
  padding: 8px;
  box-sizing: border-box;

  cursor: pointer;
`

export const BodyContainer = styled.div`
  height: calc(100% - 61px);
`

export const NavContainer = styled.div`
  height: ${NAV_BAR_HEIGHT}px;

  padding: 0px 24px;
  box-sizing: border-box;
`

export const ListContainer = styled.div<{ hidden?: boolean; navBarIsHidden?: boolean }>`
  height: calc(
    100% - ${BUTTON_CONTAINER_HEIGHT}px - ${({ navBarIsHidden }) => (navBarIsHidden ? 0 : NAV_BAR_HEIGHT)}px
  );

  padding: 0px 24px 16px;
  box-sizing: border-box;

  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
  overflow: scroll;
`

export const ButtonContainer = styled.div`
  height: ${BUTTON_CONTAINER_HEIGHT}px;

  padding: 16px 24px;
  box-sizing: border-box;
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 1px solid var(--border-neutral-faded, #dfe2ea);
  display: flex;
  justify-content: center;
`

export const PenIcon = styled.img`
  padding-right: 4px;
`
